import { render, staticRenderFns } from "./conversation-summaries.vue?vue&type=template&id=93df36ce&scoped=true&"
import script from "./conversation-summaries.vue?vue&type=script&lang=js&"
export * from "./conversation-summaries.vue?vue&type=script&lang=js&"
import style0 from "./conversation-summaries.vue?vue&type=style&index=0&id=93df36ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df36ce",
  null
  
)

export default component.exports